import { Genre } from './types';

export const genres: Genre[] = [
  {
    id: 'academic',
    name: 'Ensayo Académico',
    description: 'Escritura formal con estructura argumentativa y referencias',
    icon: '🎓',
    color: '#3B82F6',
    structure: ['Introducción', 'Marco Teórico', 'Desarrollo', 'Conclusiones', 'Referencias'],
    prompt: 'Eres un experto en escritura académica. Ayuda con estructura formal, argumentación sólida, uso de fuentes, metodología y rigor académico.'
  },
  {
    id: 'novel',
    name: 'Novela/Ficción',
    description: 'Narrativa larga con personajes, tramas y diálogos complejos',
    icon: '📖',
    color: '#8B5CF6',
    structure: ['Prólogo', 'Capítulo 1', 'Desarrollo', 'Clímax', 'Desenlace'],
    prompt: 'Eres un experto en escritura de novelas. Ayuda con desarrollo de personajes, estructura narrativa, diálogos naturales y técnicas literarias.'
  },
  {
    id: 'scientific',
    name: 'Artículo Científico',
    description: 'Investigación con metodología, datos y análisis riguroso',
    icon: '🔬',
    color: '#10B981',
    structure: ['Abstract', 'Introducción', 'Metodología', 'Resultados', 'Discusión', 'Conclusiones'],
    prompt: 'Eres un experto en redacción científica. Ayuda con metodología clara, análisis de datos, conclusiones basadas en evidencia y formato científico.'
  },
  {
    id: 'theater',
    name: 'Teatro/Guión',
    description: 'Formato dramático con diálogos, acotaciones y estructura teatral',
    icon: '🎭',
    color: '#EF4444',
    structure: ['Acto I', 'Acto II', 'Acto III', 'Personajes', 'Escenografía'],
    prompt: 'Eres un experto en escritura teatral y guiones. Ayuda con diálogos naturales, acotaciones claras, estructura dramática y desarrollo de personajes.'
  },
  {
    id: 'journalism',
    name: 'Artículo Periodístico',
    description: 'Información clara, objetiva y estructurada para audiencia amplia',
    icon: '📰',
    color: '#F59E0B',
    structure: ['Lead', 'Desarrollo', 'Contexto', 'Declaraciones', 'Cierre'],
    prompt: 'Eres un experto en periodismo. Ayuda con leads atractivos, información clara, estructura de pirámide invertida y estilo periodístico.'
  },
  {
    id: 'blog',
    name: 'Blog/Substack',
    description: 'Contenido conversacional y engagement con la audiencia',
    icon: '✍️',
    color: '#F97316',
    structure: ['Hook', 'Introducción', 'Puntos Clave', 'Call to Action', 'Cierre'],
    prompt: 'Eres un experto en content marketing y blogging. Ayuda con tono conversacional, engagement, estructura atractiva y calls to action efectivos.'
  }
];

const UNDEFINED_GENRE = {
  id: 'undefined',
  name: 'Indefinido',
  icon: '❓',
  color: '#888888',
  description: 'Aún no has decidido el género de tu obra. Puedes escribir libremente y decidirlo más adelante.',
  structure: [],
  prompt: '', // requerido por el tipo Genre
};

export const genresWithUndefined = [UNDEFINED_GENRE, ...genres];